import { Cesium } from 'app/cesium';
import { Cartographic } from './path_profile';

export function cartesianFromCartographic(cartographic: Cartographic): Cesium.Cartesian3 {
    const radians = !cartographic.degrees;
    if (radians) {
        return Cesium.Cartesian3.fromRadians(
            cartographic.longitude,
            cartographic.latitude,
            cartographic.height,
        );
    }
    return Cesium.Cartesian3.fromDegrees(
        cartographic.longitude,
        cartographic.latitude,
        cartographic.height,
    );
}

export function movePointCloserToCentreOfTheEarth(c: Cesium.Cartesian3): Cesium.Cartesian3 {
    const carto = Cesium.Cartographic.fromCartesian(c);
    carto.height -= 10;
    return Cesium.Cartographic.toCartesian(carto);
}

// credit: https://sandcastle.cesium.com/?src=Hello%20World.html&label=Showcases&gist=d917ac40dfb225cb9899a84403b0c719

export function minDistanceBetween(
    totalDistance: number,
    maxPoints: number,
    minPoints: number,
    idealDistanceBetween: number,
): number {
    const pointsRequired = totalDistance / idealDistanceBetween;

    // clamp to maxPoints
    if (pointsRequired >= maxPoints) {
        return totalDistance / maxPoints;
    }

    // clamp to minPoints
    if (pointsRequired <= minPoints) {
        return totalDistance / minPoints;
    }

    return totalDistance / pointsRequired;
}

export function distancesBetween(totalDistance: number, distanceBetween: number): number[] {
    const distances = [];

    let distancesToMake = Math.floor(totalDistance / distanceBetween);

    // If we have an exact division ignore the last digit
    if (totalDistance % distanceBetween === 0) {
        --distancesToMake;
    }

    let i = 0;
    while (i < distancesToMake) {
        i++;
        distances.push(i * distanceBetween);
    }

    return distances;
}
